import React from 'react';
import { ProductPrice } from 'src/types/global-types';

import { StyledText } from '../Helpers/Price';
import { useVatCausesRender } from '../AppShell/VatProvider';
import { PriceBadge } from '../ProductDetail/PriceBadge';
import { Price } from '../Helpers/Price';

import classes from './ProductMainPrice.scss';

export const ProductMainPrice: React.FC<{ price: Pick<ProductPrice, 'price' | 'price_incl'> }> = ({ price }) => {
    const { vat } = useVatCausesRender();
    if (price.price === -1 && price.price_incl === -1) {
        return (
            <>
                <span className={classes.productMainPrice}>
                    <StyledText>...</StyledText>
                </span>
                <PriceBadge price={price.price} />
            </>
        );
    }

    return <Price price={price.price} priceIncl={price.price_incl} vat={vat} className={classes.productDetailPrice} />;
};
